export const DATAFIELD_WITH_DATATYPE_TAG_PREFIX = 'df';
export const METRIC_TAG_PREFIX = 'metric';
